import React from 'react';

import { OrgPageAccessGate } from '@/components/OrgPageAccessGate';
import { useShouldShowWorkforceConsole } from '@/hooks/useShouldShowWorkforceConsole';

/**
 * Blocks direct URL access to the Workforce Console unless the sidebar would
 * show it (`useShouldShowWorkforceConsole`: team leads, or with
 * `permissions_based_wc_access` on, the permission map, the PQC rule and the
 * `hide_workforce_console_<org_id>` blocklist). Renders nothing while the flags
 * and checks load, or while the URL's org is not yet the selected one, so a
 * deep link is not bounced early (`OrgPageAccessGate`).
 */
export function WorkforceAccessGate({ children }: { children: React.ReactNode }) {
  return <OrgPageAccessGate {...useShouldShowWorkforceConsole()}>{children}</OrgPageAccessGate>;
}
